module.exports = __webpack_public_path__ + "static/media/mysql.b9d31709.png";